﻿import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {Field, reduxForm} from 'redux-form';
import {renderSelectField, renderSwitchField, renderTextField} from '../../components/core/editors';
import {connect} from 'react-redux';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import {AppBar, CircularProgress, FlatButton, IconButton, LinearProgress, MenuItem, Paper} from 'material-ui';
import service from '../../services/member-services';

class MemberDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
        this.handleDeleteClose = this.handleDeleteClose.bind(this);
        this.deleteConfirmed = this.deleteConfirmed.bind(this);

        this.memberId = context.router.params.memberId;
    }

    componentDidMount() {
        this.props.onGetMember(this.memberId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    submitForm(data) {
        this.props.onSubmitMember(data);
    }

    onDeleteConfirm() {
        this.props.onConfirmDeleteMember(true);
    }

    handleDeleteClose() {
        this.props.onConfirmDeleteMember(false);
    }

    deleteConfirmed() {
        this.props.onDeleteMember(this.memberId);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const {handleSubmit, pristine, submitting, inProgress, saving, openDeleteDialog} = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Member editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack/></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" disabled={pristine || submitting}/>}
                    />
                    <div style={{margin: 100}}>
                        <CircularProgress size={100} thickness={5}/>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true}>
                    <AppBar title="Member editor editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack/></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit"/>}
                    />

                    <Paper className="template-edit-form" zDepth={1}>
                        {saving ? <LinearProgress mode="indeterminate"/> : null}

                        <Field name="Id" type="hidden" component={renderTextField} label="Id"/>
                        <Field disabled name="Reporter" component={renderTextField} label="Reporter Id" tooltip="Reporter Id"/>
                        <Field disabled name="FirstName" component={renderTextField} label="First Name" tooltip="First Name"/>
                        <Field disabled name="LastName" component={renderTextField} label="Last Name" tooltip="Last Name"/>

                        <Field name="ApiSecretToken" component={renderTextField} label="API Secret Token" tooltip="Api Secret Token"/>
                        <Field name="ApiAllowedIpAddresses" component={renderTextField} label="API Allowed IP Addresses" tooltip="API Allowed IP Addresses separated by ','"/>

                        <Field name="MemberEmail" component={renderTextField} label="Member Email" tooltip="Member Email - to send 2FA code"/>
                        <Field name="MobileNumber" component={renderTextField} label="Mobile Number" tooltip="Member Mobile Number - to send 2FA code as sms"/>
                        <Field required name="TwoFactorAuthEnabled" component={renderSwitchField} label="Enable 2FA" tooltip="Enable or disable two factor authentication"/>

                        <Field required name="TwoFactorAuthType" component={renderSelectField} label="2FA Type" tooltip={<span>2FA Type</span>}>
                            <MenuItem value="emailType" primaryText="Email"/>
                            <MenuItem value="smsType" primaryText="SMS"/>
                        </Field>

                        <Field required name="DisableDataSubmit" component={renderSwitchField} label="Disable Data Submit" tooltip="Enable or disable Data Submit from mobile app"/>
                    </Paper>
                </form>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = ['SourceId', 'FeedType'];
    requiredFields.forEach(field => {
        if (!values[field] && values[field] !== 0) {
            errors[field] = 'Required';
        }
    });
    if (isNaN(Number(values.MinListeners))) {
        errors.MinListeners = 'Must be a number'
    } else if (Number(values.MinListeners) < 0) {
        errors.MinListeners = 'Sorry, value must be positive'
    }
    return errors;
};

const mapStateToProps = state => ({...state.members});

const mapDispatchToProps = dispatch => ({
    onGetMember: (id) =>
        dispatch({
            type: 'REQUEST_MEMBER', payload: id > 0 ? service.MembersServices.getMember(id) : {
                FeedType: 0,
                MinListeners: 0
            }
        }),
    onSubmitMember: (member) =>
        dispatch({type: 'SUBMIT_MEMBER', payload: service.MembersServices.postMember(member)}),
    onConfirmDeleteMember: (open) =>
        dispatch({type: 'CONFIRM_DELETE_MEMBER', payload: open}),
    onDeleteMember: (id) =>
        dispatch({type: 'DELETE_MEMBER', payload: service.MembersServices.deleteFeedSource(id)}),
    onUnload: () =>
        dispatch({type: 'MEMBER_PAGE_UNLOADED'})
});

MemberDetails.contextTypes = {
    router: React.PropTypes.any.isRequired
};

MemberDetails = reduxForm({
    form: 'memberForm',
    enableReinitialize: true,
    validate
})(MemberDetails);

MemberDetails = connect(mapStateToProps, mapDispatchToProps)(MemberDetails);

export default MemberDetails;